export default "__VITE_ASSET__CyAwZip3__"